import { FeeCatalog, PaymentFee } from '@melio/platform-api';

export const getPushToDebitFixedFee = (paymentFees: PaymentFee[]) =>
  paymentFees.find((fee) => fee.type === 'push-to-debit')?.amount;

export const getPushToDebitPercentFee = (feeCatalogEntries: FeeCatalog[]) =>
  feeCatalogEntries.find((entry) => entry.feeType === 'push-to-debit' && entry.valueType === 'percent')?.value;
